import { useState, useCallback } from 'react';
import { api } from '../services/apiClient';
import { todayStr } from '../utils/formatters';

export function useStats() {
  const [stats, setStats] = useState({});

  const loadStats = useCallback(() => {
    api.stats(todayStr()).then(setStats).catch(() => {});
  }, []);

  return { stats, loadStats };
}
